import React from 'react';
import styled from '@emotion/styled';
import Quote from './Icons/Quote';
import BlessingIcon from './Icons/Blessing';

export default function Hadeth() {
  return (
    <Wrapper>
      <TopLeftCalligraphy>
        <BlessingIcon />
      </TopLeftCalligraphy>

      <BottomLeftQuote>
        <Quote />
      </BottomLeftQuote>

      <TopRightQuote>
        <Quote />
      </TopRightQuote>

      <Content>
        <Intro>Allah Der Mächtige und Erhabene sprach:</Intro>

        <MainQuote>
          „Meine Liebe ist verpflichtend für diejenigen,
          <br />
          die sich um Meinetwillen gegenseitig lieben,
          <br />
          die sich um Meinetwillen zusammensetzen,
          <br />
          die sich um Meinetwillen gegenseitig besuchen
          <br />
          und die sich um Meinetwillen gegenseitig unterstützen.”
        </MainQuote>

        <Signature>Prophet Muhammad ﷺ</Signature>
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  position: relative;
  max-width: 1216px;
  margin: 16px auto 0px auto;
  min-height: 520px;
  padding: 120px 118px 80px 118px;

  @media (max-width: 1024px) {
    min-height: 520px;
    padding: 100px 64px 72px 64px;
  }

  @media (max-width: 768px) {
    min-height: auto;
    padding: 72px 24px 64px 24px;
  }

  @media (max-width: 480px) {
    padding: 56px 16px 48px 16px;
  }
`;

const Content = styled.div`
  position: relative;
  margin-left: auto;
  width: 100%;
  max-width: 735px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  z-index: 2;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const Intro = styled.div`
  margin-bottom: 2px;
  font-family: 'Crimson Text', serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  color: #2c2a28;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

const MainQuote = styled.div`
  font-family: 'Crimson Text', serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 1.2;
  text-align: right;
  color: #181d27;

  @media (max-width: 1024px) {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 1.25;

    br {
      display: none;
    }
  }

  @media (max-width: 480px) {
    font-size: 21px;
  }
`;

const Signature = styled.div`
  margin-top: 14px;
  font-family: 'Crimson Text', serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  color: #3a3836;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-top: 12px;
  }
`;

const TopLeftCalligraphy = styled.div`
  position: absolute;
  top: -400px;
  left: -300px;
  z-index: 0;
  opacity: 0.9;
  pointer-events: none;

  svg {
    display: block;
    width: 850px;
    height: auto;
  }

  @media (max-width: 1024px) {
    top: -300px;
    left: -240px;

    svg {
      width: 700px;
    }
  }

  @media (max-width: 768px) {
    top: -180px;
    left: -160px;
    opacity: 1;

    svg {
      width: 460px;
    }
  }

  @media (max-width: 480px) {
    top: -170px;
    left: -120px;

    svg {
      width: 360px;
    }
  }
`;

const TopRightQuote = styled.div`
  position: absolute;
  top: 0px;
  right: -280px;
  z-index: 1;
  pointer-events: none;

  svg {
    display: block;
    width: 328px;
    height: 245px;
  }

  @media (max-width: 1024px) {
    top: 8px;
    right: 12px;

    svg {
      width: 240px;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    top: 8px;
    right: 8px;
    opacity: 0.55;

    svg {
      width: 150px;
      height: auto;
    }
  }

  @media (max-width: 480px) {
    svg {
      width: 110px;
    }
  }
`;

const BottomLeftQuote = styled.div`
  position: absolute;
  left: -270px;
  bottom: -50px;
  z-index: -1;
  transform: rotate(180deg);
  pointer-events: none;

  svg {
    display: block;
    width: 290px;
    height: 216px;
  }

  @media (max-width: 1024px) {
    left: 12px;
    bottom: 0;

    svg {
      width: 220px;
      height: auto;
    }
  }

  @media (max-width: 768px) {
    left: 0;
    bottom: 8px;
    opacity: 0.5;

    svg {
      width: 140px;
      height: auto;
    }
  }

  @media (max-width: 480px) {
    svg {
      width: 110px;
    }
  }
`;
